/**
 * Preloads approval data for SSR.
 */

import type { QueryInteropSupportedResult } from '@confluence/apollo-relay-interop/entry-points/query.ts';
import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';
import { fg } from '@confluence/feature-gating';

import ApprovalsContextApprovalsDataQuery from './__generated__/ApprovalsContextApprovalsDataQuery.graphql.ts';
import type {
	ApprovalsContextApprovalsDataQuery$data,
	ApprovalsContextApprovalsDataQuery$variables,
} from './__generated__/ApprovalsContextApprovalsDataQuery.graphql.ts';

export type PreloadApprovalsParams = {
	cloudId: string;
	contentId: string;
	contentStatus: 'CURRENT' | 'DRAFT';
	spaceKey: string;
};

export function preloadApprovals({
	cloudId,
	contentId,
	contentStatus,
	spaceKey,
}: PreloadApprovalsParams): Promise<
	QueryInteropSupportedResult<ApprovalsContextApprovalsDataQuery$data>
> {
	const otherContentStatus = contentStatus === 'CURRENT' ? 'DRAFT' : 'CURRENT';

	return queryInterop<
		ApprovalsContextApprovalsDataQuery$data,
		ApprovalsContextApprovalsDataQuery$variables
	>({
		query: ApprovalsContextApprovalsDataQuery,
		variables: {
			cloudId,
			contentId,
			contentStatus,
			otherContentStatus,
			transitionType: null,
			spaceKey,
			includeApprovalsBetaFeatures: fg('confluence_approvals_beta'),
		},
	});
}
